const menu = {
    label: '• Instrumentos',
    to: '/sol/tiposervico',
    rules: ['SOL-001'],
};

export default menu;
